function s(a) {
  return this.__data__.has(a);
}
var t = s;
export {
  t as _
};
//# sourceMappingURL=index.es380.js.map
